import { useMemo } from 'react';
import { formatJson } from '../lib/format';
import { CopyButton } from './CopyButton';

interface JsonBlockProps {
  value: unknown;
  label?: string;
  maxHeight?: number;
}

export function JsonBlock({ value, label = 'Payload', maxHeight = 420 }: JsonBlockProps) {
  const text = useMemo(() => formatJson(value), [value]);
  const isEmptyObject = text === '{}';

  return (
    <figure className="json-block">
      <figcaption className="json-block__bar">
        <span className="json-block__label">{label}</span>
        <CopyButton value={text} />
      </figcaption>
      {isEmptyObject ? (
        <p className="json-block__empty">Empty object — this event carried no payload fields.</p>
      ) : (
        <pre className="json-block__body" style={{ maxHeight }} tabIndex={0}>
          <code>{text}</code>
        </pre>
      )}
    </figure>
  );
}
